import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  BackButton,
  Error,
  Loading,
  MaterialTransactionTypeForm,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import { Button, Card } from '@mui/material';
import PropTypes from 'prop-types';

import * as actions from '@/redux/actions';

export default function EditMaterialTransactionType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const materialTransactionType = useSelector(
    (state) => state.materialTransactionType,
  );
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: materialTransactionType.name,
      direction: materialTransactionType.direction,
    },
  });

  useEffect(() => {
    dispatch(actions.materialTransactionTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log(data);
      await dispatch(actions.materialTransactionTypePut(id, data));
      alert('สำเร็จ');
      await dispatch(actions.materialTransactionTypeGet(id));
    } catch (error) {
      console.log(error);
    }
  };
  if (materialTransactionType.isLoading || materialTransactionType.rows) {
    return <Loading />;
  }
  if (
    !materialTransactionType.isLoading &&
    materialTransactionType.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaterialTransactionTypeForm
                errors={errors}
                materialTransactionType={materialTransactionType}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditMaterialTransactionType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditMaterialTransactionType.defaultProps = {
  title: '',
  subtitle: '',
};
